import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
// Note: this should extend LoginProviderType
export var LoginMethod;
(function (LoginMethod) {
    LoginMethod["Password"] = "Password";
    LoginMethod["SSO"] = "SSO";
    LoginMethod["Google"] = "Google";
})(LoginMethod || (LoginMethod = {}));
/**
 * This config is public and should not contain any secrets. Use OpenIDClientConfiguration for private data
 */
export class LoginMethodConfig extends AutoEncoder {
    /**
     * Full name of this login method. e.g. 'Sign in with Google'
     */
    loginButtonText = null;
    /**
     * Full name of this login method. e.g. 'Sign in with Google'
     */
    fullName = null;
    /**
     * Full name of this login method. e.g. 'Google'
     */
    shortName = null;
    /**
     * Limit this method to email addresses ending on these domains.
     * When this is empty, all domains are allowed.
    */
    allowlist = [];
    /**
     * Disallow this method for email addresses ending on these domains
     */
    blocklist = [];
    isEnabledForEmail(email) {
        // Validate that the user is allowed to use this method
        const emailDomain = email.split('@')[1].toLowerCase();
        if (!emailDomain) {
            return false;
        }
        for (const blocked of this.blocklist) {
            if (emailDomain === blocked.toLowerCase()) {
                return false;
            }
        }
        if (this.allowlist.length > 0) {
            for (const allowed of this.allowlist) {
                if (emailDomain === allowed.toLowerCase()) {
                    return true;
                }
            }
            return false;
        }
        return true;
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], LoginMethodConfig.prototype, "loginButtonText", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], LoginMethodConfig.prototype, "fullName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], LoginMethodConfig.prototype, "shortName", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], LoginMethodConfig.prototype, "allowlist", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], LoginMethodConfig.prototype, "blocklist", void 0);
//# sourceMappingURL=LoginMethod.js.map